import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { AuthService } from 'src/app/providers/auth.service';
import { NotificationAttachment } from '../models/notification-attachment.model';

@Injectable({ providedIn: 'root' })
export class NotificationAttachmentService {
  private objectUrls = new Set<string>();

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  resolveDownloadUrl(url: string): string {
    if (!url) { return url; }
    if (url.startsWith('http://') || url.startsWith('https://')) { return url; }
    if (url.startsWith('/commApi/')) { return url; }
    if (url.startsWith('/downloads/')) { return `/commApi${url}`; }
    if (url.includes('/downloads/')) {
      const idx = url.indexOf('/downloads/');
      return `/commApi${url.slice(idx)}`;
    }
    return url;
  }

  fetchBlob(attachment: NotificationAttachment): Observable<Blob> {
    const url = this.resolveDownloadUrl(attachment.url);
    const token = this.authService.getUser?.accessToken;
    const headers = token ? new HttpHeaders({ xaccesstoken: token }) : undefined;
    return this.http.get(url, { responseType: 'blob', headers });
  }

  downloadFile(attachment: NotificationAttachment): void {
    this.fetchBlob(attachment).subscribe({
      next: (blob) => saveAs(blob, attachment.fileName || 'attachment'),
      error: () => { /* caller may show error */ }
    });
  }

  createObjectUrl(blob: Blob): string {
    const url = URL.createObjectURL(blob);
    this.objectUrls.add(url);
    return url;
  }

  revokeObjectUrl(url: string): void {
    if (!url) { return; }
    URL.revokeObjectURL(url);
    this.objectUrls.delete(url);
  }

  revokeAllObjectUrls(): void {
    this.objectUrls.forEach((url) => URL.revokeObjectURL(url));
    this.objectUrls.clear();
  }

  toAttachmentsFromLegacy(
    location?: string,
    fileName?: string,
    mimeType?: string,
    fileSize?: number
  ): NotificationAttachment[] {
    if (!location) { return []; }
    return [{
      url: location,
      fileName: fileName || 'attachment',
      mimeType,
      fileSize
    }];
  }
}
